import { FC } from 'react';
import { Panel } from '@cbridge-tools/resizable-panels';
import { Box, Toolbar, useTheme } from '@mui/material';
import { ResizeHandle } from '@cbridge-tools/resize-handle';
import { ISidePanelProps, SidePanelVariant } from './SidePanel.interface';
import { getSidePanelStyle } from './SidePanel.style';
import { panelSizes } from './SidePanel.constant';

export const SidePanel: FC<ISidePanelProps> = (props) => {
  const { variant, children } = props;
  const theme = useTheme();

  const isLeft = variant === SidePanelVariant.Left;

  const panelSize = panelSizes[variant];

  return (
    <>
      {!isLeft && <ResizeHandle highlightSide={'start'} />}

      <Panel
        id={variant}
        {...panelSize}
        tagName={isLeft ? 'nav' : 'aside'}
      >
        <Box sx={getSidePanelStyle(theme, isLeft)}>
          <Toolbar />
          {children}
        </Box>
      </Panel>

      {isLeft && <ResizeHandle highlightSide={'end'} />}
    </>

  );
};
